import type * as React from "react";
import { styled } from "~/common/mui";
import {
  C_INFORMATION_CONTAINER,
  C_ON_INFORMATION_CONTAINER,
  C_ON_SURFACE,
  C_WHITE,
  C_NOTIFICATION,
  C_ON_NOTIFICATION,
  C_SALES_CAMPAIGN,
  C_ON_SALES_CAMPAIGN,
} from "~/common/components/icon/Colors";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";

interface Props {
  type?: "blue" | "grey" | "notification" | "salesCampaign";
}

const StyledRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "type",
})<Props>(({ type }) => ({
  ...getFontStyle(FontSize.LabelLarge),
  backgroundColor: C_ON_SURFACE,
  color: C_WHITE,
  borderRadius: "4px",
  display: "inline-flex",
  alignItems: "center",
  padding: "2px 8px",

  ...(type === "blue" && {
    backgroundColor: C_INFORMATION_CONTAINER,
    color: C_ON_INFORMATION_CONTAINER,
  }),
  ...(type === "notification" && {
    backgroundColor: C_NOTIFICATION,
    color: C_ON_NOTIFICATION,
  }),
  ...(type === "salesCampaign" && {
    backgroundColor: C_SALES_CAMPAIGN,
    color: C_ON_SALES_CAMPAIGN,
  }),
}));

export const Chip: React.FC<React.HTMLAttributes<HTMLDivElement> & Props> = ({ type, ...props }) => (
  <StyledRoot type={type} {...props} />
);

export default Chip;
